import React, { Component } from 'react';
import WidgetHeader from './WidgetHeader';

class WidgetPracticeHeader extends Component {
  render() {
    const { practice, loading } = this.props;
    return (
      <WidgetHeader
        title={loading ? '' : practice.display}
        photo={loading ? '' : practice.logo}
        photo2x={loading ? '' : practice.logo2x}
        showBackButton
      />
    );
  }
}

export default WidgetPracticeHeader;
